import { indexItems } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-800 text-xs font-medium mb-4 whitespace-nowrap">
            <i className="ri-grid-line"></i>
            内容专区
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            主题内容索引
          </h2>
          <p className="text-sm text-foreground-500 mt-2">七大内容专区，发现你感兴趣的吃瓜方向</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {indexItems.map((item, idx) => (
            <a
              key={idx}
              href="#ranking"
              onClick={(e) => {
                e.preventDefault();
                const el = document.querySelector('#ranking');
                if (el) el.scrollIntoView({ behavior: 'smooth' });
              }}
              className={`group p-5 rounded-xl border cursor-pointer transition-all ${
                idx === 0
                  ? 'lg:col-span-2 lg:row-span-2 bg-gradient-to-br from-primary-50 to-primary-100 border-primary-200 hover:border-primary-300'
                  : 'bg-background-50 border-background-200/70 hover:border-primary-200'
              }`}
            >
              <div className={`w-10 h-10 flex items-center justify-center rounded-xl mb-3 ${
                idx === 0
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-accent-100 text-accent-600'
              }`}>
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <div className="flex items-center gap-2 mb-1.5">
                <h3 className="text-sm font-heading font-bold text-foreground-900">{item.title}</h3>
                <span className="text-[10px] text-foreground-400 bg-background-200/70 px-1.5 py-0.5 rounded whitespace-nowrap">
                  {item.count}篇
                </span>
              </div>
              <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              {idx !== 0 && (
                <div className="flex items-center gap-1 mt-3 text-xs text-primary-500 opacity-0 group-hover:opacity-100 transition-opacity">
                  <span>进入专区</span>
                  <i className="ri-arrow-right-line text-[10px]"></i>
                </div>
              )}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}